import { apiService } from "@/services";
import { useMutation, useQuery } from "@tanstack/react-query";
import { handleApiError } from "@/utils";
import queryClient from "@/query-client";
import { DEFAULT_STALE_TIME } from "@/constants";

export interface EventPreferences {
  signal: boolean;
  rank_change: boolean;
  landscape_complete: boolean;
  ab_test_results: boolean;
}

const EVENT_PREFERENCES_KEY = ["event-preferences"];

export const useGetEventPreferences = () =>
  useQuery<EventPreferences>({
    queryKey: EVENT_PREFERENCES_KEY,
    queryFn: () => apiService.get<EventPreferences>("/event-preferences"),
    staleTime: DEFAULT_STALE_TIME,
    refetchOnMount: "always",
  });

export const useUpdateEventPreferences = () =>
  useMutation<EventPreferences, unknown, Partial<EventPreferences>>({
    mutationFn: (body) =>
      apiService.put<EventPreferences, Partial<EventPreferences>>("/event-preferences", body),
    onSuccess: (data) => {
      queryClient.setQueryData(EVENT_PREFERENCES_KEY, data);
    },
    onError: (error) => handleApiError(error),
  });
